import createStyleSheet from "If_AdTool/common/createStyleSheet";
import SendUrls from "If_AdTool/common/sendUrl";
import UiTool from "If_AdTool/common/UiTool";
import BaiduAd from "../utils/baidu";
import Pc360Ad from "../utils/360";
function renderFn(adData,el) {
    let { 
        img, 
        link, 
        txt, 
        click_imp_arr, 
        imp_arr, 
        type = "html", 
        tuid = "", 
        data360="",//360广告数据
        isTemplet ="",// on 模版中发曝光
        w,
        h,
        showFlow=false,//是否展示普通信息流
     } = adData;
    let isClose = false;//是否关闭
    var floatEl = createFloatEl(adData, function () {
        isClose = true;
    });
   
    window.IfengAmgr.eventEmitter && window.IfengAmgr.eventEmitter.on("windowAdOpen", function () {
        //浮动关闭
        floatEl.hide();
        //隐藏浮动信息流，
    })
    window.IfengAmgr.eventEmitter && window.IfengAmgr.eventEmitter.on("windowAdClose", function () {
        if (!isClose){
              //浮动需要显示
            floatEl.show();
            //展示浮动信息流，
        }
    })
    floatEl.show();
    if (isTemplet == "on") {
        SendUrls(imp_arr);
    }
    if (!showFlow){
        if (el.parentNode.childNodes.length==1){
            el.parentNode.style.display="none";
        }
        return;
    }

    if (type=="html"){
        let style =`.feedTW02{
            position:relative;
            overflow:hidden;
            width:254px;
            height:40px
            left:0;
            top:0;
        }
        .feedTW02 .pic-feedTW02{
            width: 72px;
            height: 40px;
            padding:0;
            float:left;
            overflow:hidden;
            margin-right:15px;
            position:relative;
            -webkit-transition:all .3s;
            transition:all .3s
        }
        .pic-feedTW02 img{
            vertical-align:bottom;
            display:block;
        }
        .feedTW02:hover .pic-feedTW02{
            -webkit-transform:scale(1.1);
            -ms-transform:scale(1.1);
            transform:scale(1.1);
        }
        .feedTW02 .text-feedTW02{
            // width:98%
        }
       
        .feedTW02 .text-feedTW02 h2{
            width:166px !important;
            height:44px !important;
            line-height:20px;
            overflow: hidden;
            text-overflow: ellipsis;
            color: #222222;
            font-size: 15px;
            text-decoration:none
        }
        .feedTW02:hover h2{
            color: #f54343;
        }
        .feedTW02:hover{
        }
        .feedTW02 .text-feedTW02 p{
            font-size:12px;color:#999
        }
        .adlogo-feedTW02{
            width:28px;
            height:17px;
            position: absolute;
            bottom:0px;
            left: 0;
            opacity: .8;
            transform: scale(.8);
        }`
        // let style = `.feedTW1{position:relative;overflow:hidden;width:254px;height:40px}.feedTW1 a {width:72px !important;height:40px !important;margin-right:10px}.pic-feedTW1{width: 72px;height: 40px;float:left;overflow:hidden;margin-right:20px;position:relative}.pic-feedTW1 img{vertical-align:bottom;display:block;-webkit-transition:all .5s;transition:all .5s}.pic-feedTW1:hover img{-webkit-transform:scale(1.04);-ms-transform:scale(1.04);transform:scale(1.04)}.text-feedTW1{width:98%;}.text-feedTW1 h2{height:26px}.text-feedTW1 h2 a{width:166px !important;height:44px !important;line-height:21px;overflow: hidden;text-overflow: ellipsis;color: #222222;font-size: 15px;text-decoration:none}.text-feedTW1 h2 a:hover{color: #f54343;}.text-feedTW1 p{color: #999999;font-size: 14px;margin-top: 50px;}.adlogo-feedTW1{width:28px;height:17px;position: absolute;bottom: 0;left: 0;}`
        //
        let cName = "feedTW02"
        let className = cName + '-' + window.IfengAmgr.uuid();
        style = style.replace(new RegExp(cName, "g"), className);
        createStyleSheet(style);
        let imgcontainer = 'imgcontainer-' + window.IfengAmgr.uuid();
        let content = `<a class="${className}" href="${link}" target="blank">
                          <div href="${link}" class="pic-${className}" id="${imgcontainer}" target="blank">
                                <img class="img-${className}" src="${img}"/>
                            </div>
                        <img src="https://x0.ifengimg.com/feprod/c/feprod/c/ifengimcp/pic/20210108/3677f2773fd79f12b079_size1_w56_h34.png" class="adlogo-${className}">
                        <div class="text-${className}">
                            <h2>
                                ${txt}
                            </h2>
                        </div>
                   </a>`;
        el.innerHTML = content;
        UiTool.imgResize(imgcontainer, adData.img, 3);
        if (isTemplet=="on"){
            let aEl = document.querySelector(`.${className}`);
            aEl.addEventListener("click", () => {
                SendUrls(click_imp_arr);
            })
        }
    } else if (type == "baidu") {
        BaiduAd({
            tuid,//百度 tuid
            w,//宽
            h, //高
        },el);
    } else if (type == "360") {
        Pc360Ad({
            data360,//百度 tuid
            w,//宽
            h, //高
        }, el);
    }
};
function createFloatEl(adData,closeFn=null){
    let { floatImgTxtAdEl=null} = window.IfengAmgr;
    if (floatImgTxtAdEl){
        return floatImgTxtAdEl;
    }
    let { img, link, txt, ap, click_imp_arr, tuid2 = "", type = "html", isTemplet = "", data360 } = adData;
    let floatEl = document.createElement("div");
    floatEl.style.cssText = `position: fixed;
    transition: all 300ms;
    width: 306px;
    display: block;
    left: 50%;
    bottom: -300px;
    z-index: 9999;
    background-color: bisque;
    margin-left:312px;
    background-image: url(http://x0.ifengimg.com/feprod/c/2023_3_7/11_18_21/bg.png);
    background-size: cover;
    box-shadow: 0 1px 12px 0 rgb(153 153 153 / 30%);
    background-size: cover;
    background-repeat: no-repeat;
    border-radius: 8px;
    `
    floatEl.show =function(){
        floatEl.style.bottom = "60px";
    }
    floatEl.hide = function () {
        floatEl.style.bottom = "-300px";
    }
    floatEl.setAttribute(IfengAmgr.pex, ap);
    document.body.appendChild(floatEl);

    window.IfengAmgr.floatImgTxtAdEl = floatEl;

    let id = "g" + window.IfengAmgr.uuid();
    let css = `.info-intro{
        padding: 15px;
     }
     .info-intro::before{
        position: absolute;
        top: -2px;
        left: -3px;
        display: inline-block;
        content: "";
        width: 8px;
        height: 8px;
        background: #fa3939;
        border: 1px solid #fff;
        border-radius: 6px;
     }
     .info-intro a:hover{
        text-decoration: none;
     }
     .info-intro .content{
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            width: 100%;
            align-items: center;
            
     } 
     .info-intro .content .imgBox{
           width: 100px;
        height: 100px;
        z-index: 1;
        position: relative;
        left: 0px;
        bottom: 0px;
     } 
     .info-intro .content .imgBox .img{
            width:100%;
            height:100%;
     } 
     .info-intro .content .adTag{
            width: 28px;
            height: 17px;
            overflow: hidden;
            position: absolute;
            right: 0px;
            top: 0px;
            z-index: 2;
            opacity: 0.8;
            transform:scale(.8);
            transform-origin: top right;
     } 
     
     .info-intro .content .txt{
            font-size: 14px;
            font-weight:bold;
            width: 160px;
            color: #000;
            line-height: 24px;
            overflow:hidden; 
            text-overflow:ellipsis;
            display:-webkit-box; 
            -webkit-box-orient:vertical;
            -webkit-line-clamp:4; 
     }
     .info-intro .close{
            position: absolute;
            right: 0px;
            top: 0px;
            padding: 8px;
            width: 12px;
            height: 12px;
            z-index:11;
            cursor: pointer;
     }`;
    css = css.replace(/info\-intro/g, id);
    createStyleSheet(css);
    if (type == "html") {
        let html = `<div class="info-intro">
        <a class="content" href="${link}" target="_blank">
            <div class="imgBox">
                <img  class="img"></img>
                <img src ="https://x0.ifengimg.com/feprod/c/feprod/c/ifengimcp/pic/20210108/3677f2773fd79f12b079_size1_w56_h34.png" class="adTag" >
            </div>
            <span class="txt">${txt}</span>
        </a>
        <img src="http://x0.ifengimg.com/feprod/c/2023_3_7/11_18_21/close.svg" class="close"/>
    </div>`;
        html = html.replace(/info\-intro/g, id);
        floatEl.innerHTML = html;
      
        let closeBtn = floatEl.querySelector(`.close`);
        let clA = floatEl.querySelector("a");
        closeBtn.addEventListener("click", () => {
            floatEl.style.display = "none";
            closeFn && closeFn();
        })
        let imgEl = floatEl.querySelector(`.imgBox img`);
        let concentEl = floatEl.querySelector(`.imgBox`);
        imgEl.onload = (e) => {
           let height = Math.round(imgEl.naturalHeight * concentEl.offsetWidth / imgEl.naturalWidth);
            concentEl.style.height = height + "px";
        }
        imgEl.src = img;
        if (isTemplet == "on") {
            clA.addEventListener("click", () => {
                SendUrls(click_imp_arr);
            })
        }
    } else if (type == "baidu") {
        let html = `<div class="info-intro">
        <div class="content">
          <div class="imgBox">
                <div class="img"></div>
                <img src ="https://x0.ifengimg.com/feprod/c/feprod/c/ifengimcp/pic/20210108/3677f2773fd79f12b079_size1_w56_h34.png" class="adTag" >
          </div>
        </div>
        <img src="http://x0.ifengimg.com/feprod/c/2023_3_7/11_18_21/close.svg" class="close"/>
    </div>`;
        html = html.replace(/info\-intro/g, id);
        floatEl.innerHTML = html;
        let closeBtn = floatEl.querySelector(`.close`);
        closeBtn.addEventListener("click", () => {
            floatEl.style.display = "none";
            closeFn && closeFn();
        })
        let clA = floatEl.querySelector(".imgBox .img");
        clA.parentNode.style.height = clA.style.height = "75px";
        clA.style.width = "276px";
        clA.style.overflowY = "hidden";
        BaiduAd({
            tuid: tuid2,//百度 tuid
            w:276,//宽
            h:75, //高
            closeFn:()=>{
                floatEl.style.display="none";
            },
            renderOk:(el)=>{
                el.style.marginTop = "-28px";
            }
        }, clA);
      
    } else if (type == "360") {
        //  
        let html = `<div class="info-intro">
        <div class="content">
          <div class="imgBox">
                <div class="img"></div>
                <img src ="https://x0.ifengimg.com/feprod/c/feprod/c/ifengimcp/pic/20210108/3677f2773fd79f12b079_size1_w56_h34.png" class="adTag" >
          </div>
        </div>
        <img src="http://x0.ifengimg.com/feprod/c/2023_3_7/11_18_21/close.svg" class="close"/>
    </div>`;
        html = html.replace(/info\-intro/g, id);
        floatEl.innerHTML = html;
        let closeBtn = floatEl.querySelector(`.close`);
        closeBtn.addEventListener("click", () => {
            floatEl.style.display = "none";
            closeFn && closeFn();
        })
        let clA = floatEl.querySelector(".imgBox .img");
        clA.parentNode.style.height = clA.style.height = "75px";
        clA.style.width = "276px";
        clA.style.overflowY = "hidden";
        Pc360Ad({
            data360,//百度 tuid
            w: 276,//宽
            h: 75, //高
            hasAdTag:false,//是否需要360广告标签
            closeFn: () => {
                floatEl.style.display = "none";
            },
            renderOk: (el) => {
                floatEl.style.display = "block";
            }
        }, clA);
       // floatEl.style.display = "none";
    }
    return floatEl;
}
if(typeof  window.IfengAmgr !=undefined){
    window.IfengAmgr.tplLib.floatVideoImgTxtFlow = { render: renderFn,version:"1.0.0"};
}

